"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _contexts = require("../../contexts");
var _services = require("../../services");
var _styles = _interopRequireDefault(require("./styles"));
var _utils = require("../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable react/jsx-no-bind */ // Contexts
// Services
// Styles
var Chapter = /*#__PURE__*/_react.default.memo(_ref => {
  var _rendition$book;
  var {
    chapter
  } = _ref;
  var {
    jumpToPage,
    selectedChapter,
    setSelectedChapter,
    sessionToken,
    uuid,
    bookTitle,
    rendition
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    isDesktopView,
    setOpenDrawer
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var {
    repaintHighlight
  } = (0, _react.useContext)(_contexts.HighlightsContext);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var service = (0, _services.TrackingsService)(appToken, sessionToken);
  var [cfi, setCfi] = (0, _react.useState)();
  var classes = (0, _styles.default)();
  (0, _react.useEffect)(() => {
    if (rendition && chapter.href) {
      (0, _utils.getCfiByHref)(rendition, chapter.href).then(result => {
        setCfi(result);
      }).catch(error => {
        console.error('Error calculating CFI for', chapter.label, ':', error);
        setCfi(null);
      });
    }
  }, [rendition, chapter.href]);
  var handleItemClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* () {
      if (cfi) {
        yield jumpToPage(cfi);
        repaintHighlight(rendition);
        setSelectedChapter(chapter.id);
        service.trackChapterSelected({
          uuid,
          titleCover: bookTitle,
          selectedChapter: chapter.label
        });
        if (!isDesktopView) setOpenDrawer(false);
      } else {
        console.log('Chapter: Cannot navigate - CFI is null for:', chapter.label);
      }
    });
    return function handleItemClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    button: true,
    selected: selectedChapter === chapter.id,
    onClick: () => handleItemClick()
  }, /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    className: classes.chapterItem,
    primary: chapter.label,
    secondary: cfi ? "P\xE1gina ".concat((rendition === null || rendition === void 0 || (_rendition$book = rendition.book) === null || _rendition$book === void 0 || (_rendition$book = _rendition$book.locations) === null || _rendition$book === void 0 ? void 0 : _rendition$book.locationFromCfi(cfi)) || 'N/A') : 'Carregando...'
  })), (chapter.subitems && chapter.subitems.length) > 0 ? chapter.subitems.map(child => /*#__PURE__*/_react.default.createElement(Chapter, {
    chapter: child,
    jumpToPage: jumpToPage,
    selectedChapter: selectedChapter,
    setSelectedChapter: setSelectedChapter,
    key: child.id
  })) : null);
});
var ChaptersList = /*#__PURE__*/_react.default.memo(() => {
  var classes = (0, _styles.default)();
  var {
    chapters
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  return /*#__PURE__*/_react.default.createElement(_List.default, {
    component: "nav",
    className: classes.root
  }, chapters.map(chapter => /*#__PURE__*/_react.default.createElement(Chapter, {
    chapter: chapter,
    key: chapter.id
  })));
});
Chapter.propTypes = {
  chapter: _propTypes.default.shape({
    id: _propTypes.default.string,
    href: _propTypes.default.string,
    label: _propTypes.default.string,
    subitems: _propTypes.default.arrayOf(_propTypes.default.object)
  }).isRequired
};
var _default = exports.default = ChaptersList;